<template>
  <div class="search-container">
    <div class="text-slate hover:cursor-pointer" @click="toggleSearch" tabindex="0">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" class="w-5 h-5 hover:text-clay">
        <title>Search</title>
        <path
                d="M21.9 18.3c1.2-1.8 1.9-4 1.9-6.4C23.8 5.3 18.5 0 11.9 0 5.3 0 0 5.3 0 11.9s5.3 11.9 11.9 11.9c2.4 0 4.6-.7 6.5-1.9l.5-.4 8.5 8.5 2.6-2.7-8.5-8.5.4-.5zM18.5 5.2c1.8 1.8 2.8 4.1 2.8 6.6s-1 4.9-2.8 6.6-4.1 2.8-6.6 2.8-4.9-1-6.6-2.8-2.8-4.1-2.8-6.6 1-4.9 2.8-6.6 4.1-2.8 6.6-2.8 4.9 1.1 6.6 2.8z"
                fill="currentColor" />
      </svg>
    </div>

    <div class="modal" v-show="displaySearch">
      <div class="modal-content mb-12">
        <div class="flex">
          <button class="modal-closer close ml-auto border-0 bg-white">
            <svg xmlns="http://www.w3.org/2000/svg" width="16.4" height="16.4" viewBox="0 0 16.4 16.4">
              <title>close</title>
              <path data-name="Path 5"
                    d="M14.562,0,8.2,6.363,1.837,0h0L0,1.838,6.362,8.2,0,14.563,1.837,16.4,8.2,10.038,14.562,16.4,16.4,14.563h0L10.038,8.2,16.4,1.838h0L14.562,0Z"
                    transform="translate(0 0)" />
            </svg>
          </button>
        </div>
        <form name="search" role="search" method="get" id="searchform mb-24" action="/" class="searchform">
          <div class="form-item search-field flex justify-center m-12 gap-8">
            <input id="search-form-input" type="text" :value="searchValue" name="s" placeholder="Keyword"
                   aria-label="Search" required="required" tabindex="-1" class="focus:outline-none active:outline-none">
            <button type="submit" id="search-submit" aria-label="Submit" class="btn">
              search
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        displaySearch: false,
        searchValue: null,
      }
    },

    mounted() {
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      this.searchValue = params.get('s');
    },

    methods: {
      toggleSearch() {
        this.displaySearch = !this.displaySearch;

        if (this.displaySearch) {
          this.disableScrolling();

          this.$nextTick(() => {
            document.getElementById("search-form-input").focus();
          });
        }
        else {
          this.enableScrolling();
        }
      },
      disableScrolling() {
        this.scrollPosition = window.pageYOffset;

        const $body = document.querySelector('body');
        $body.style.overflow = 'hidden';
        $body.style.position = 'fixed';
        $body.style.top = `-${this.scrollPosition}px`;
        $body.style.width = '100%';
      },
      enableScrolling() {
        const $body = document.querySelector('body');
        $body.style.removeProperty('overflow');
        $body.style.removeProperty('position');
        $body.style.removeProperty('top');
        $body.style.removeProperty('width');

        window.scrollTo(0, this.scrollPosition);
      },
    },
    created() {
      const onEscape = (e) => {
        if (this.displaySearch && e.keyCode === 27) {
          this.displaySearch = false;
          this.enableScrolling();
        }
      }

      document.addEventListener('keydown', onEscape)

      this.$once('hook:destroyed', () => {
        document.removeEventListener('keydown', onEscape)
      })
    }
  }
</script>
